/**
 * Track A：第一方聚合流量追蹤（P0 行銷基建 2026-09-16）
 * 原則：sendBeacon 一發即忘；不存 cookie、不存個人資料；追蹤失敗永遠靜默。
 */

const TRACK_URL = 'https://jkd-whatsapp-verification.jimsbond007.workers.dev/track';
const REF_KEY = 'jkd_ref';
const REF_TTL_MS = 30 * 86400000;

export interface TrackPayload {
  page?: string;
  locale?: string;
  event?: string;
  referrer?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
}

/** 讀取 URL ?ref= 寫入 localStorage（30 天有效）——/gf/:code 落地時調用 */
export function captureRef(): void {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) {
      localStorage.setItem(REF_KEY, JSON.stringify({ code: ref.slice(0, 32), at: Date.now() }));
    }
  } catch {
    /* storage 不可用時靜默 */
  }
}

/** 取得當前生效的推薦碼（過期即清除） */
export function getRef(): string | undefined {
  try {
    const raw = localStorage.getItem(REF_KEY);
    if (!raw) return undefined;
    const data = JSON.parse(raw) as { code?: string; at?: number };
    if (data?.code && typeof data.at === 'number' && Date.now() - data.at < REF_TTL_MS) {
      return data.code;
    }
    localStorage.removeItem(REF_KEY);
  } catch {
    /* ignore */
  }
  return undefined;
}

/** 發送追蹤 beacon（pageview 或轉化事件）；永不 throw */
export function sendTrack(payload: TrackPayload = {}): void {
  try {
    const qs = new URLSearchParams(window.location.search);
    const body = JSON.stringify({
      page: window.location.pathname + (window.location.hash || ''),
      locale: document.documentElement.lang || undefined,
      referrer: document.referrer || undefined,
      utm_source: qs.get('utm_source') || undefined,
      utm_medium: qs.get('utm_medium') || undefined,
      utm_campaign: qs.get('utm_campaign') || undefined,
      utm_content: qs.get('utm_content') || undefined,
      ref: getRef(),
      ...payload,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(TRACK_URL, body);
    } else {
      fetch(TRACK_URL, { method: 'POST', body, keepalive: true }).catch(() => {});
    }
  } catch {
    /* 靜默 */
  }
}
